import { useEffect, useState } from 'react';

const EXPANDED_WIDTH  = 242;
const COLLAPSED_WIDTH = 64;

/**
 * useSidebarWidth
 * ─────────────────────────────────────────────────────────────
 * يرجع عرض الـ sidebar الحالي ويتابع أي تغيير فيه.
 *
 * الـ sidebar بيحفظ حالته في localStorage تحت key = 'sidebarExpanded'
 * وبيبعت event 'sidebarResized' عند كل expand/collapse.
 *
 * الاستخدام:
 *   const sidebarWidth = useSidebarWidth();
 */
export const useSidebarWidth = () => {
  // ✅ قراءة الحالة من localStorage من أول لحظة بدل ما نبدأ بقيمة ثابتة
  const getInitialWidth = () => {
    try {
      const saved = localStorage.getItem('sidebarExpanded');
      // لو مفيش قيمة محفوظة نعتبره expanded (الحالة الافتراضية)
      if (saved === null) return EXPANDED_WIDTH;
      return saved === 'false' ? COLLAPSED_WIDTH : EXPANDED_WIDTH;
    } catch {
      return EXPANDED_WIDTH;
    }
  };

  const [sidebarWidth, setSidebarWidth] = useState(getInitialWidth);

  useEffect(() => {
    // استمع لأي تغيير من الـ sidebar
    const handler = (e) => {
      const w = e.detail?.width;
      if (w !== undefined) setSidebarWidth(w);
    };
    window.addEventListener('sidebarResized', handler);
    return () => window.removeEventListener('sidebarResized', handler);
  }, []);

  return sidebarWidth;
};